var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcDiscover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcDiscover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover-Copy-3",
    transform: "translate(-122.000000, -70.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.146258,86.4547593 L136.105177,82.4952509 C136.083701,82.4742075 136.058508,82.459499 136.036066,82.4399119 C136.831218,81.2580593 137.295304,79.8433458 137.295304,78.3219591 C137.295304,74.1833998 133.87132,70.8284705 129.647652,70.8284705 C125.423983,70.8284705 122,74.1833998 122,78.3218863 C122,82.4602999 125.423909,85.8153021 129.647578,85.8153021 C131.200353,85.8153021 132.644111,85.3605754 133.85029,84.5814599 C133.87028,84.6033771 133.885217,84.6280612 133.906694,84.6491046 L137.947849,88.6087586 C138.554914,89.2035077 139.539119,89.2035077 140.146258,88.6087586 C140.753249,88.0139367 140.753249,87.0495811 140.146258,86.4547593 Z M129.647652,83.217571 C126.888103,83.217571 124.651126,81.0257081 124.651126,78.3218863 C124.651126,75.6179916 126.888178,73.4261287 129.647652,73.4261287 C132.407052,73.4261287 134.644104,75.6180644 134.644104,78.3218863 C134.644104,81.0257081 132.407052,83.217571 129.647652,83.217571 Z",
    id: "onboardingIcDiscover"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcDiscover);
export default __webpack_public_path__ + "static/media/onboardingIcDiscover.e5adb4d1a40b2664b500c35d2858f1fb.svg";
export { ForwardRef as ReactComponent };